import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from 'Constants';
import isExternal from 'is-url-external';
import Api from 'Root/libs/analytics/Api';

const Anchor = props => {
  if( isExternal(props.to) )

  {
 return    <a 
      onClick={()=>{
        if(props.code)
        {
          Api.recordAcitity(props.code);
        }
      }}
      target="_blank" rel="noopener" href={props.to} {...props} />
    }
    else
    {
 
      if(props.to){
      if(!props.to.includes('id='))
      {
         if(location.search)
         {
          props.to=`${props.to}${location.search}`;
         } 
      }
    }
  
  return  (
    <Link   onClick={()=>{
      if(props.code)
      {
        Api.recordAcitity(props.code);
      }
    }} {...props} />
  );
    }
};

export default styled(Anchor)`
  position: relative;
  color: ${props => props.color || colors.accent};
  text-decoration: none;
  cursor: pointer;

  ::after {
    ${props =>
    props.underline || (props.underline === undefined && "content: '';")}
    background-color: ${props => props.color || colors.accent};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    width: 0;
    transition: 0.2s width;
  }

  :hover::after {
    width: 100%;
  }
`;
